<template>
  <div class="chawgt-webchat-satisfaction-survey">
    <div class="chawgt-webchat-satisfaction-body">
      <h2 v-if="content.title" class="chawgt-webchat-pre">{{ content.title }}</h2>
      <template v-else>
        <h2>{{ $t('survey.title') }}</h2>
        <p>{{ $t('survey.subtitle') }}</p>
      </template>
      <div class="chawgt-webchat-satisfaction-rating-wrapper">
        <star-rating v-model="rating" :item-size="20"
          :show-rating="false" />
        </div>
    </div>
    <div class="chawgt-webchat-satisfaction-footer">
      <button class="chawgt-webchat-satisfaction-button"
              :disabled="disabled"
              v-on:click="cancelRating()" >
        {{ $t('Cancel') }}
      </button>
      <button class="chawgt-webchat-satisfaction-button"
              :disabled="disabled"
              v-on:click="sendRating()">
        {{ $t('Send') }}
      </button>
    </div>
    <!-- <span class="chawget-msg-date">{{ formatDate(date) }}</span> -->
  </div>
</template>

<script>
import BaseMessage from '@/components/messages/BaseMessage.vue'
import { StarRating } from 'vue-rate-it'

export default {
  name: 'SurveyChoice',
  extends: BaseMessage,
  components: { StarRating },
  data () {
    return {
      disabled: this.content.disabled,
      rating: this.content.satisfaction
    }
  },
  methods: {
    cancelRating () {
      if (this.disabled === false) {
        this.rating = -1
        this.sendRating()
      }
    },
    sendRating () {
      if (this.disabled === false) {
        this.disabled = true
        if (this.rating !== undefined) {
          this.$store.dispatch({
            type: 'webchat/sendMsg',
            content: this.rating.toString(),
            richContent: null
          })
        }
      }
    }
  }
}

</script>

<style lang="scss" scoped>
@import '@/assets/scss/global.scss';

.chawgt-webchat-widget-wrapper {

  .chawgt-webchat-pre {
    white-space: pre-line;
  }

  .chawgt-webchat-satisfaction-survey {
    background: $grey;
    border-radius: 5px;
    display: block;
    text-align: center;
    margin: 10px 23px;
    padding-top: 10px;
    overflow: hidden;

    .chawgt-webchat-satisfaction-body * {
      display: block;
      padding: 5px;
      text-align: center;
      color: $content;
    }

    .chawgt-webchat-satisfaction-rating-wrapper {
      display: flex;
      justify-content: center;
    }
  }

  .chawgt-webchat-satisfaction-footer {
    border-top: 1px solid darken($color: $grey, $amount: 10%);
    display: block;
    height: 35px;
  }

  .chawgt-webchat-satisfaction-button {
    border: none;
    height: 34px;
    margin: 0;
    padding: 0px;
    text-align: center;
    width: calc(50% - 3px);
    color: $content;
    width: 50%;

    &:hover {
      background-color: darken($color: $grey, $amount: 10%);
      cursor: pointer;

      &[disabled="disabled"] {
        cursor: not-allowed;
        background-color: transparent;
      }
    }

  }

    .chawgt-webchat-satisfaction-button + .chawgt-webchat-satisfaction-button {
      border-left: 1px solid darken($color: $grey, $amount: 10%);
    }
}
</style>
